import { Dispatch, SetStateAction, useState } from "react";
import { Dropdown, Button, FormField, Modal} from "@weirgroup/weir-dls";
import { EXPORT_DROPDOWN_ITEMS } from "../../../constants/shoppinglist.constant";
import { useTranslation } from "react-i18next";
import { emailShoppingList, exportShoppingList } from "../../../api/shopping-list.api";
import FileSaver from "file-saver";
import { isValidEmail } from "../../../utils/email.util";
import { SetFunctionType } from "../../../types/utils.type";
import { processResult } from "../../../utils/process-result.util";
import { StorageService } from "../../../services/storage_service"
import { useAnalyticsEvent } from "../../../hooks/useAnalyticsEvent";
import { LoadingSpinner } from "../../../components/loading-spinner";
interface Props {
    isModalShown: boolean,
    setIsModalShown: Dispatch<SetStateAction<boolean>>;
    setToastData: Dispatch<SetStateAction<any>>;
    setShowToast: Dispatch<SetStateAction<any>>;
    darkMode?:boolean;
}

export const ExportModal = (props: Props) => {
    const logAnalyticsEvent = useAnalyticsEvent();
    const { isModalShown, setIsModalShown, setToastData, setShowToast } = props;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedType, setSelectedType] = useState<string>("");
    const storageData: any = StorageService.getItem("userData")
    const userData = JSON.parse(storageData)
    const [email, setEmail] = useState<string>(userData ? userData.email : "")
    const [emailValidation,setEmailValidation] = useState<string>("")
    const { t } = useTranslation();

    const setFunctions: SetFunctionType = { setIsModalShown, setToastData, setShowToast, setIsLoading }

    const onModalClose = () => {
        setIsModalShown(false);
    }

    const downloadFile = () => {
        setIsLoading(true);
        exportShoppingList(selectedType).then((result: any) => {
            const file = new File([result.data], "Shopping List", { type: result.headers['content-type'] });
            FileSaver.saveAs(file);
            processResult(setFunctions, t('downloadSuccessful'), true)
            logAnalyticsEvent('web_user_exported_shopping_list', { description: 'User exported shopping list', exportType: 'file' });
        }).catch((err: any) => {
            const message = err.response.data.message ?? t('downloadFailed')
            processResult(setFunctions, message, false)
        })
    }

    const sendList = () => {
        setIsLoading(true)
        if (isValidEmail(email)) {
            emailShoppingList(email).then(() => {
                processResult(setFunctions, t("emailSuccessMessage"), true)
                logAnalyticsEvent('web_user_exported_shopping_list', { description: 'User exported shopping list', exportType: 'email' });
            }).catch((err: any) => {
                const message = err.response.data.message ?? t("emailFailMessage")
                processResult(setFunctions, message, false)
            })
        } else {
            setIsLoading(false)
            setToastData({
                variant: 'critical',
                message: t('validEmailMessage'),
            })
            setShowToast(true)
        }
    }

    return (
        <div className="export-modal">
            {isLoading ?<LoadingSpinner darkMode={props.darkMode} />: <></>}
            <Modal
                darkMode={props.darkMode}
                showModal={isModalShown}
                onClose={() => onModalClose()}
                size="small"
                closeOnBackdropPress
            >
                <div className="modal-header">
                    <p className="modal-title" style={{color: props.darkMode ? "white": "black"}}>{t('exportModalTitle')}</p>
                </div>
                <p className="modal-subtitle" style={{color: props.darkMode ? "white": "black"}}>{t('exportModalSubtitle')}</p>
                <div className="dropdown">
                    <Dropdown
                        darkMode={props.darkMode}
                        name="fileType"
                        value={selectedType ?? ""}
                        setValue={(e:any) => setSelectedType(e)}
                        size={"sm"}
                        selectData={EXPORT_DROPDOWN_ITEMS}
                        selectSize={EXPORT_DROPDOWN_ITEMS.length + 1}
                        placeholderText={"Select File Type"}
                        modalType={"small"}
                        optionsOverlay={false}
                         />
                        
                </div>
                <div style={{ marginBottom: 20 }}></div>
                {selectedType == "email" ?
                    <FormField
                        darkMode={props.darkMode}
                        name="InputBox"
                        required={true}
                        label={t("email")}
                        size={"sm"}
                        width={"100%"}
                        placeholder={t("enterEmail")}
                        onChange={(e:any) => {
                            setEmail(e.target.value)
                            setEmailValidation(e.target.value)
                        }}
                        defaultValue={email}
                    /> : <></>
                }
                <div style={{ marginBottom: 20 }}></div>
                <div className="download-button">
                    {selectedType == "email" ?
                        <Button
                            darkMode={props.darkMode}
                            label={t("send")}
                            iconName={"Mail"}
                            size={'sm'}
                            variant={'primary'}
                            onClick={() => sendList()}
                            disabled={!isValidEmail(email) || emailValidation === ""}
                        /> :
                        <Button
                            darkMode={props.darkMode}
                            label={t("download")}
                            iconName={"download"}
                            size={'sm'}
                            variant={'primary'}
                            onClick={() => downloadFile()}
                            disabled={!selectedType}
                        />
                    }
                </div>
            </Modal>

        </div>
    )
}
  